import { render, staticRenderFns } from "./Cellphone.vue?vue&type=template&id=4f4cf953&scoped=true&"
import script from "./Cellphone.vue?vue&type=script&lang=js&"
export * from "./Cellphone.vue?vue&type=script&lang=js&"
import style0 from "./Cellphone.vue?vue&type=style&index=0&id=4f4cf953&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4cf953",
  null
  
)

export default component.exports